/**
 * 
 * @param deg The amount of degrees to be converted.
 * @returns Returns supplied degree amount converted to radians.
 */
export const degreesToRadians = (deg) => (deg * Math.PI) / 180;

/**
 * 
 * @param rad The amount of radians to be converted.
 * @returns Returns supplied radian amount converted to degrees.
 */
 export const radiansToDegrees = (rad) => (rad * 180) / Math.PI;

/**
 * 
 * @param perc A percentage value (0.00 - 1.00) of 360 degrees to be converted. 
 * @returns Returns the percentage of a circle's circumference converted to degrees.
 */
export const percentToDegrees = (perc) => perc * 360;

/**
 * 
 * @param perc A percentage value (0.00 - 1.00) of 360 degrees to be converted.
 * @returns Returns the number of radians converted from a given percentage of 360 degrees
 */
export const percentToRadians = (perc) => degreesToRadians(percentToDegrees(perc));
